import { render } from "./ButtonClose.vue?vue&type=template&id=ac30e80a"
import script from "./ButtonClose.vue?vue&type=script&lang=js"
export * from "./ButtonClose.vue?vue&type=script&lang=js"

import "./ButtonClose.vue?vue&type=style&index=0&id=ac30e80a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__